import { storage } from '@goldblack/client-storage';

function addConsole(log) {
    storage.transience.addState('consoleLog', log);

    // scroll to bottom
    let consoleEnd = document.getElementById('consoleEnd');
    if (consoleEnd) {
        window.requestAnimationFrame(() => {
            const container = consoleEnd.parentElement;
            if (container) container.scrollTop = container.scrollHeight;
        });
    }
}

function setClientFilter(name, filterTypes) {
    const myFilters = [];
    for (const filterType of filterTypes) {
        myFilters.push({
            filterId: filterType._id,
            name: filterType.name,
            value: JSON.stringify(['']),
            inputValue: JSON.stringify(['']),
            display: JSON.stringify(['']),
            hashValue: filterType.code,
        });
    }
    storage.transience.setState(name, myFilters);
}

export { addConsole, setClientFilter };
